import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import ServiceSectionComponent from "../../components/home/Service/ServiceSectionComponent";
import GradientHeader from "../../components/product/GradientHeader";

const headtitle = "Our Services";
const headsubTitle = "当社のサービス";
const headsubdec = "サービス";

const ServicesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Helmet>
        <title>ITサービス一覧 | システム開発・コンサル・Odoo | グローバルジャパンネットワーク</title>
        <meta
          name="description"
          content="グローバルジャパンネットワークは、システム開発、Odoo導入、ITコンサル、エンジニアリングなど多様なサービスで企業のDXをサポートします。"
        />
        <meta property="og:title" content="ITサービス一覧 | システム開発・コンサル・Odoo | グローバルジャパンネットワーク" />
        <meta property="og:description" content="グローバルジャパンネットワークは、システム開発、Odoo導入、ITコンサル、エンジニアリングなど多様なサービスで企業のDXをサポートします。" />
        <meta property="og:url" content="https://gjnetwork.jp" />
        <meta property="og:image" content="https://gjnetwork.jp/img/global-japan-og-img.jpg" />
        <link rel="canonical" href={`https://gjnetwork.jp${window.location.pathname}`} />
      </Helmet>
      {/* <ServiceHeader /> */}
      <GradientHeader
        title={headtitle}
        subTitle={headsubTitle}
        subdesc={headsubdec}
      />
      <ServiceSectionComponent />
    </>
  );
};

export default ServicesPage;
